import React from 'react';
import ReactDOM from 'react-dom';
import CategoriesMenu from './CategoriesMenu';

const element = typeof document !== 'undefined' && document.querySelector('#CategoriesMenu-component');

if (element) {
    const props = window.initialData.CategoriesMenu;

    ReactDOM.render(<CategoriesMenu {...props} />, element);
}

export default CategoriesMenu;
